var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBellIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2901 7.61536C11.8694 7.61536 9.77456 10.1845 7.68177 14.8132C6.45751 17.9803 5.84881 21.3516 5.88855 24.7467C8.91103 26.9504 12.5495 28.1488 16.2901 28.173C20.0305 28.1488 23.669 26.9504 26.6916 24.7467C26.732 21.3518 26.1239 17.9803 24.9005 14.8132C22.8056 10.1845 20.7108 7.61536 16.2901 7.61536Z",
    stroke: "#8890B1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31.2986C18.0262 33.5671 13.9736 33.5671 11 31.2986M14.334 4H17.666",
    stroke: "#8890B1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBellIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BellIcon.1f1ab9c1.svg";
export { ForwardRef as ReactComponent };